export const MODULE = 'core'
